import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Button, Box } from '@mui/material'
import React from 'react'
import useModals from 'src/Hooks/useModals'
import { Badge } from '../components'
import { useSystemSettingsTitleAndBreadcrumbs } from 'src/Libs/system-settings'
import { AccordionItem } from '@e3dc-react/shell/Elements/Accordion'
import useAccordionStyle from 'src/Libs/styles'
import { BadgeDto } from '../types'
import { InformationBanner } from '../../general'
import { BannerLocations, BannerQueue } from 'src/Libs/banners'
import { useInstallationAccessRightsContext } from 'src/Libs/installation-rights-management/provider/InstallationAccessRightsContext'

interface BadgesPageProps {
  installationId: number
  badges: BadgeDto[] | null
}

/** User-level badges page to manage charging station badges */
export const BadgesPage: React.FC<BadgesPageProps> = ({ installationId, badges }) => {
  const { t } = useCustomTranslation()
  const { openEditBadgeDialog } = useModals()
  const { classes } = useAccordionStyle()

  const { hasInstallationWritingRights: userCanEdit } = useInstallationAccessRightsContext()
  useSystemSettingsTitleAndBreadcrumbs({ pageTitleKey: 'framework.end-user.badges' })

  const handleOpenAddEditor = (): void => openEditBadgeDialog({ installationId, initialBadge: null })
  const settingsTitle = t('user-settings.badges-page.settings-title')

  return (
    <>
      <BannerQueue location={BannerLocations.FlowSettingsRfidChargingCards} sx={{ mb: 2, mt: [2, 0] }} />
      <AccordionItem title={settingsTitle} expanded accordionDetailsSx={{ px: 4, py: 0 }} className={classes.accordion}>
        <Box pb={2}>
          <InformationBanner message={t('user-settings.badges-page.information')} />
        </Box>

        {badges?.map(badge => (
          <Badge key={badge.id ?? ''} installationId={installationId} badge={badge} />
        ))}
        <Box pb={4}>
          <Button variant="outlined" color="primary" onClick={handleOpenAddEditor} disabled={!userCanEdit}>
            {t('user-settings.badges-page.add-badge')}
          </Button>
        </Box>
      </AccordionItem>
    </>
  )
}
